import { CSSProperties } from 'react';
import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';
import { VStack } from '@cbhq/cds-web/layout';

import { CONTENT_WIDTH } from '../Organization/constants';

const resourceListStyle: CSSProperties = {
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'thin',
};

type NavigationDropdownContentProps = {
  children: React.ReactNode;
  maxHeight?: CSSProperties['maxHeight'];
};

export function NavigationDropdownContent({ children, maxHeight }: NavigationDropdownContentProps) {
  const { isPhone } = useBreakpoints();

  return (
    <VStack
      width={isPhone ? '100%' : CONTENT_WIDTH}
      maxHeight={maxHeight}
      style={resourceListStyle}
    >
      {children}
    </VStack>
  );
}
